import { ModelingUtil } from '@ispm/shared/bpmn-io/modeling-util';
import { TreeNavigator } from '@ispm/shared/bpmn-io/services/tree-navigator';
import CommandHandler from 'diagram-js/lib/command/CommandHandler';
import { NodeType } from '@ispm/shared/bpmn-io/node-type';
import { ShapeFocus } from '@ispm/shared/bpmn-io/services/shape-focus';
import Selection from 'diagram-js/lib/features/selection/Selection';
import EventBus from "diagram-js/lib/core/EventBus";
import { EventType } from '@ispm/shared/bpmn-io/bpmn-js';

export class NodeNavigatorWithDataHandler implements CommandHandler {

  constructor(private elementRegistry,
              private treeNavigator: TreeNavigator,
              private selection: Selection,
              private shapeFocus: ShapeFocus,
              private eventBus: EventBus) {
  }

  postExecute(context): any {
    const nodeId = context.elementId;
    const openPanel = !!context.openPanel;
    const data = context.data;
    const element = this.elementRegistry.get(nodeId);

    if (element) {
      if (ModelingUtil.getNodeIncomingConnections(element, true).length === 0) {
        this.navigateToFloatedNode(element, data);
      } else {
        this.navigateToNode(element, data);
      }
      if (openPanel) {
        this.eventBus.fire(EventType.OPEN_PANEL, { element});
      }
    } else {
      console.error('nodeId: ' + nodeId + ' not found in pathway viewer');
    }
  }

  private navigateToFloatedNode(node, data) {
    const neighborhoodID = node.businessObject.neighborhoodID;
    const neighborhoodIDElement = neighborhoodID ? this.elementRegistry.get(neighborhoodID) : undefined;
    const ancestors = neighborhoodIDElement ? ModelingUtil.getNodeAncestors(neighborhoodIDElement) : [];
    this.treeNavigator.navigateToMainTree();
    this.navigateToNodeByAncestors(node, ancestors, data);
  }

  private navigateToNode(node, data) {
    const ancestors = ModelingUtil.getNodeAncestors(node);
    this.treeNavigator.navigateToMainTree();
    this.navigateToNodeByAncestors(node, ancestors, data);
  }

  private navigateToNodeByAncestors(node, ancestors, data) {
    if (node) {
      const nodes = [...ancestors, [node]]; // in case 'node' is a neighborhood head node
      this.navigateToSubTree(nodes);
      if (!!data) {
        this.shapeFocus.setDefaultFocusOnShapeWithRightShift(node, data);
      } else {
        this.shapeFocus.setDefaultFocusOnShape(node);
      }
      this.selection.select(node);
    }
  }

  private navigateToSubTree(ancestors) {
    ancestors.forEach((ancestor, index) => {
      // stop navigating if the latest node is neighborhood entry
      if (index === ancestors.length - 1 && ModelingUtil.getNodeType(ancestor[0]) === NodeType.neighborhood_entry) {
        return;
      } else {
        if (this.navigateToSubTreeByEntry(ancestor[0])) {
          return;
        }
      }
    });
  }

  private navigateToSubTreeByEntry(node): boolean {
    const nodeType = ModelingUtil.getNodeType(node);
    if (nodeType === NodeType.neighborhood_entry) {
      this.treeNavigator.navigateToSubTree(node);
      return true;
    }
    return false;
  }

}


